import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

export default function Lights() {
  const lightRef = useRef();

  useFrame((state) => {
    lightRef.current.position.z = state.camera.position.z + 1;
    lightRef.current.target.position.z = state.camera.position.z;

    lightRef.current.target.updateMatrixWorld();
  });

  return (
    <>
      <directionalLight
        ref={lightRef}
        castShadow
        position={[4, 4, 1]}
        intensity={1.5}
        shadow-mapSize={[2048, 2048]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />
      <ambientLight intensity={0.5} />
    </>
  );
}
